<div class="blocked-entity">
  <div class="blocked-entity__card">
    <div class="blocked-entity__icon">
      <icon name="offline_pin" width="40" height="40"></icon>
    </div>
    <h1 class="blocked-entity__title">
      {{ 'preferredOrg.blocked.title' | translate: { entity: entityName } }}
    </h1>
    <p class="blocked-entity__body"
      [innerHTML]="'preferredOrg.blocked.body' | translate: { current: currentName, entity: entityName, preferred: preferredName }">
    </p>
  </div>
</div>
